const AchivementData = [
    {
      id: 1,
      category: "coding",
      year: "",
      title: "4-star at HackerRank on C++,10 days of code",
    },
    {
      id: 2,
      category: "coding",
      year: "",
      title: "4-star at HackerRank on SQL and Python",
    },
    {
      id: 3,
      category: "coding",
      year: " ",
      title: "Solve more than 50 questions on LeetCode",
    },
    {
      id: 4,
      category: "coding",
      year: " ",
      title: "Solved many DSA Questions of codeStudio",
    },
    {
      id: 5,
      category: "web",
      year: "10-2023",
      title: "Passed ReactJS ,CSS Test on HackerRank",
    },
    {
      id: 6,
      category: "web",
      year: "11-2024 ",
      title: "Passed SQL Test on HackerRank",
    },
    {
      id: 7,
      category: "web",
      year: "2023",
      title: "Earned Linkedin Badge of HTML,CSS,JavaScript,Frontend",
    },
    {
      id: 8,
      category: "web",
      year: "2023",
      title: "Earned Linkedin Badge of ReactJS, NodeJS",
    },
  ]
  
  export default AchivementData